{
	"backToManageDeclarations": "Înapoi la gestionarea declarațiilor"
}
